import { render, staticRenderFns } from "./gdpr-buttons.vue?vue&type=template&id=25bf2e0f&"
import script from "./gdpr-buttons.vue?vue&type=script&lang=js&"
export * from "./gdpr-buttons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports